import React from 'react'
import './game-dashboard-mobile.styles.scss'
import ImageContainer from '@/components/SHARED/image-container/image-container.component'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowUpRightFromSquare, faBell, faFlask, faUsers } from '@fortawesome/free-solid-svg-icons'
import DataCard from './data-card.component'
import { useNavigate } from 'react-router-dom'
import ActivityList from './activity-list.component'
import Chart3 from './chart3.component'
import LeadersList from './leaders-list.component'
import FeaturedContent from './featured-content.component'
import Chart4 from './chart4.component'

const GameDashboardMobile = ({
    gameData,
    gameActivity,
    defaultActivityRecords,
    playerList,
    gameElements,
    actionItems,
    activityCounts,
    gameManagers,
    role,
}) => {

    const navigate = useNavigate();

    return (
        <div className='game-dashboard-mobile'>
            {
                (gameData) &&
                <div className='game-dashboard-mobile-grid'>
                    <div className='image-div'>
                        <ImageContainer
                            className={`header-image ${gameData.border_header}-border`}
                            src={gameData.header}
                            alt={gameData.gameName} />
                    </div>
                    <div className='g-card title-card'>
                        <h4>{gameData.gameName}</h4>   
                    </div>
                    <div className='info-grid'>
                        <DataCard 
                            icon={faUsers}
                            data={gameData.playerCount ?? 0}
                            text='Players'
                            onclick={() => navigate('players')} 
                            role={role}
                        />
                        <DataCard 
                            icon={faBell}
                            data={
                                actionItems ? 
                                Object.values(actionItems)
                                .filter(a => a.status === 'pending')
                                .length : 
                                0
                            }
                            text='Pending'
                            // onclick={() => navigate('actionitems')} 
                            role={role}
                        />
                        <DataCard 
                            icon={faFlask}
                            data={gameData.createdElementTotal ?? 0}
                            text='Game Elements'
                            onclick={() => navigate('elements')} 
                            role={role}
                        />
                    </div>
                    <div className='activity-graph g-card'>
                        <div className='chart-text'>Activity Over Last 10 Days</div>
                        {
                            (activityCounts) &&
                            <Chart4 
                                activityCounts={activityCounts}
                                chartHeight={150} />
                        }
                    </div>
                    <div className='leaders-box'>
                        <div className='g-card' id='leader-card'>
                            <span>Leaders</span>
                            {
                                (gameData.sortLeaders === 'currency' || gameData.sortLeaders === 'currencyTotal' ? <span>&nbsp;&#129689;</span> : <span>&nbsp;💎</span>)
                            }
                            <hr />
                            <LeadersList 
                                gameData={gameData} 
                                playerList={playerList}
                                role={role} />
                        </div>
                    </div>
                    <div className='featured-card g-card'>
                        <div>Featured Elements</div>
                        <hr />
                        <FeaturedContent 
                            gameData={gameData} 
                            gameElements={gameElements}
                            role={role} />
                    </div>
                    <div className='activity-card g-card'>
                        <div className='activity-card-title'>
                            <span>Activity</span>
                            <button 
                                className='g-button text-only'
                                onClick={() => navigate(`activity`)}
                            >
                                <FontAwesomeIcon icon={faArrowUpRightFromSquare} />
                            </button>
                        </div>
                        <hr />
                        <ActivityList 
                            gameActivity={defaultActivityRecords} 
                                playerList={playerList} 
                                gameManagers={gameManagers}
                                minumumHeight={250} />
                    </div>
                </div>
            }
        </div>
    )
}

export default GameDashboardMobile